import gaurangSahuProfileImg from "./gaurang-sahu.png"
import rishabhSinghBishtProfileImg from "./rishabh-singh-bisht.png"
import prateekAggarwalProfileImg from "./prateek-aggarwal.png"
import humraagProfileImg from "./humraag.png"
import anchorAishwariyaProfileImg from "./anchor-aishwarya.png"
import img1 from "./img1.jpg"
import img2 from "./img2.jpg"
import img3 from "./img3.jpg"
import bgImage from "./bg-image_upscaled.png"
import chatGPTImage from "./ChatGPT Image Jul 8, 2025, 12_03_06 AM.png"
import chatGPTImage2 from "./ChatGPT Image Jul 8, 2025, 12_51_05 AM.png"
import aiBgImage from "./AI_Generated_Image_2025-07-08 (1).png"
import airBrush from "./Airbrush-image-extender (1) (1).jpeg"
import extended from "./extended.png"
import landingPageSlide_1 from "./landing_page_slide_1.png"
import landingPageSlide_2 from "./landing_page_slide_2.png"
import landingPageSlide_3 from "./landing_page_slide_3.png"
import landingPageSlide_4 from "./landing_page_slide_4.png"
import landingPageSlide_5 from "./landing_page_slide_5.png"
import landingPageSlide_6 from "./landing_page_slide_6.png"
import landingPageSlide_7 from "./landing_page_slide_7.png"

export const images = {
    gaurangSahuProfileImg,
    rishabhSinghBishtProfileImg,
    prateekAggarwalProfileImg,
    humraagProfileImg,
    anchorAishwariyaProfileImg,
    img1,
    img2,
    img3,
    bgImage,
    chatGPTImage,
    chatGPTImage2,
    aiBgImage,
    airBrush,
    extended,
    landingPageSlide_1,
    landingPageSlide_2,
    landingPageSlide_3,
    landingPageSlide_4,
    landingPageSlide_5,
    landingPageSlide_6,
    landingPageSlide_7,
};